import { render, staticRenderFns } from "./SampleResultHeat.vue?vue&type=template&id=270e229f&scoped=true"
import script from "./SampleResultHeat.vue?vue&type=script&lang=js"
export * from "./SampleResultHeat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270e229f",
  null
  
)

export default component.exports